import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output,} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {InactivityService} from "../../lib/services/inactivity/inactivity.service";
import {RefreshtokenService} from "../../lib/services/autenticacion/refreshtoken.service";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import jwtDecode from "jwt-decode";
import * as moment from 'moment';
import {ToastService} from '../../lib/services/toast/toast.service';
import {AuthService} from "../../lib/services/auth/auth.service";

@Component({
    selector: 'lib-inactivity-modal',
    templateUrl: './inactivity-modal.component.html',
    styleUrls: ['./inactivity-modal.component.scss']
})
export class InactivityModalComponent implements OnInit, AfterViewInit, OnDestroy {

    public timeLeft: number = 60;
    interval: any;
    progressWidth: number = 100;
    closingSession = false;
    animationFrameId :any;
    countDownActive = false;

    @Output() endTimeEvent: EventEmitter<any> = new EventEmitter()
    displayTest = false;

    constructor(
        public inactivityService: InactivityService,
        public translate: TranslateService,
        private refreshTokenService: RefreshtokenService,
        private toastService: ToastService,
        private translateService: TranslateService,
        private authService: AuthService,
        private cdr: ChangeDetectorRef
        // private loadingService: LoadingService
    ) {
    }

    ngOnDestroy(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    ngOnInit(): void {
    }

    startTimer() {
        const totalTime = this.timeLeft
        const widthDecrement = 100 / totalTime
        this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
                this.cdr.detectChanges()
                this.progressWidth -= widthDecrement;
                if (this.progressWidth < 0) {
                    this.progressWidth = 0;
                }
            } else {
                this.stopTimer()
            }
        }, 1000)
    }

    stopTimer() {
        this.inactivityService.close()
        this.cdr.detectChanges();
        this.timeLeft = 1000;
        this.inactivityService.stopTimer();
        this.authService.logOut();
        setTimeout(()=>{
            this.cdr.detectChanges()
        },600)
    }

    continueSession() {
        this.resetCountdown()
        this.inactivityService.syncCloseModals();
        this.inactivityService.continueSession();
        this.inactivityService.resetSessionTimer();
    }

    private getTokenTime() {
        const wsoToken: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const tokenDecoded: any = jwtDecode(wsoToken)
        const tokenTime = moment(tokenDecoded.exp * 1000);
        const now = moment();
        const tokenNow = moment.duration(tokenTime.diff(now));
        return tokenNow.asSeconds();
    }

    ngAfterViewInit(): void {
        this.startCountdown(this.timeLeft)
    }

    startCountdown(durationInSeconds) {
        const endTime = moment().add(durationInSeconds, "seconds");
        this.countDownActive = true;
        
        const updateCountdown = () => {
            // Si no está activo o el modal está cerrado, no continuamos
            if (!this.countDownActive || !this.inactivityService.isModalOpen()) {
                if (this.animationFrameId) {
                    cancelAnimationFrame(this.animationFrameId);
                    this.animationFrameId = null;
                }
                return;
            }
            const now = moment();
            const remainingTime = endTime.diff(now, "seconds");
            if (remainingTime > 0) {
                this.timeLeft = remainingTime;
                this.progressWidth = (remainingTime / durationInSeconds) * 100;
                this.animationFrameId = requestAnimationFrame(updateCountdown);
                if (this.progressWidth < 0) {
                    this.progressWidth = 0;
                }
                this.cdr.detectChanges();
            } else {
                this.countDownActive = false;
                if (this.animationFrameId) {
                    cancelAnimationFrame(this.animationFrameId);
                    this.animationFrameId = null;
                }
                if (this.inactivityService.isModalOpen()) {
                    this.stopTimer();
                }
            }
        }
        updateCountdown();
    }

    resetCountdown(){
        if (this.animationFrameId){
            cancelAnimationFrame(this.animationFrameId)
            this.animationFrameId =null
        }
        this.countDownActive = false
    }
}
